export default "__VITE_ASSET__gTMMex21__"